import SectionErrorRoute from 'garaje/utils/section-error-route';

export default class DesksErrorRoute extends SectionErrorRoute {
  section = 'desks';
}
